var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"desktop-no-connected-platforms"},[_c('img',{class:_vm.imageClasses,attrs:{"src":_vm.placeholderImgSrc,"alt":"Chart placeholder showing what chart might look like"}})])}
var staticRenderFns = []

export { render, staticRenderFns }